import React from 'react'
import { useProductListContext } from './Context'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { ProductListRow } from './ProductListRow'
import { ListHeader } from './ListHeader'

export type ProductListProps = Pick<DataTableProps, 'name' | 'onRowDoubleClick'>
export const ProductList = ({ onRowDoubleClick, name = 'product-list-v4' }: ProductListProps) => {
  const { productList, listFieldConfig, productListWithSelection } = useProductListContext()
  const defaultListResult = { ...productList, list: productListWithSelection?.list }

  return (
    <DataTable
      onRowDoubleClick={onRowDoubleClick}
      name={name}
      fields={listFieldConfig}
      listResult={defaultListResult}
      row={ProductListRow}
      head={ListHeader}
      stats="products"
    />
  )
}
